import { useSelector } from 'react-redux';
import { canUseQuickbooksDesktop, canUseQuickbooksOnline } from 'resources/Organization/Features/FeaturesData';

const useQuickbooksConnections = () => {
  const qboConnected = useSelector(canUseQuickbooksOnline);
  const qbdConnected = useSelector(canUseQuickbooksDesktop);

  return (
    { qboConnected, qbdConnected }
  );
};

export default useQuickbooksConnections;
